import { Modal, KbdHint } from '@axioma/ui';

import { useUIStore } from '../stores/ui.js';

const SHORTCUTS: ReadonlyArray<{ keys: string[]; description: string }> = [
  { keys: ['G', 'A'], description: 'Ir para Agenda crítica' },
  { keys: ['G', 'K'], description: 'Ir para Kanban' },
  { keys: ['G', 'C'], description: 'Ir para Carteira' },
  { keys: ['G', 'R'], description: 'Ir para Painel de risco' },
  { keys: ['G', 'P'], description: 'Ir para Processos' },
  { keys: ['⌘', 'K'], description: 'Command palette' },
  { keys: ['⌘', 'B'], description: 'Recolher / expandir sidebar' },
  { keys: ['?'], description: 'Mostrar esta ajuda' },
  { keys: ['ESC'], description: 'Fechar modais e overlays' },
];

export function HelpModal(): JSX.Element {
  const open = useUIStore((s) => s.helpOpen);
  const setOpen = useUIStore((s) => s.setHelpOpen);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Atalhos de teclado"
      description="AXIOMA é construída para o teclado. Pressione G seguido de uma letra para navegar, ou ⌘ K para o command palette."
      size="md"
    >
      <ul className="divide-y divide-ax-line">
        {SHORTCUTS.map((s) => (
          <li
            key={s.keys.join('+')}
            className="flex items-center justify-between py-2.5"
          >
            <span className="ax-body text-ax-text-secondary">{s.description}</span>
            <KbdHint keys={s.keys} />
          </li>
        ))}
      </ul>
    </Modal>
  );
}
